import type { UppyUploadScope } from '../types/uppy-upload-scope.type';

export type UppyUploadInstanceIdKey = Pick<
  UppyUploadScope,
  'entityId' | 'fileCategoryId' | 'tusCategory'
>;

export const buildUppyUploadInstanceId = ({
  entityId,
  fileCategoryId,
  tusCategory,
}: Readonly<UppyUploadInstanceIdKey>) =>
  `${tusCategory}::${String(entityId)}::${String(fileCategoryId)}`;
